import * as React from 'react';
import { Button } from './button';

// ============================================================================
// EmptyState Types
// ============================================================================

export interface EmptyStateProps {
  /** Main heading text */
  title: string;
  /** Descriptive text below the heading */
  description: string;
  /** Optional action button */
  action?: {
    label: string;
    onClick: () => void;
  };
  /** Optional icon element to display above the title */
  icon?: React.ReactNode;
  /** Optional compact mode for smaller containers */
  compact?: boolean;
}

// ============================================================================
// EmptyState Component
// ============================================================================

export function EmptyState({ title, description, action, icon, compact }: EmptyStateProps) {
  return (
    <div className={`flex flex-col items-center justify-center text-center ${compact ? 'py-6 px-3' : 'py-12 px-4'}`}>
      {icon && (
        <div className={`text-muted-foreground/50 ${compact ? 'mb-2' : 'mb-4'}`}>
          {icon}
        </div>
      )}
      <h3 className={`font-medium text-foreground ${compact ? 'text-sm' : 'text-lg'}`}>
        {title}
      </h3>
      <p className={`mt-1 text-muted-foreground ${compact ? 'text-xs max-w-xs' : 'text-sm max-w-md'}`}>
        {description}
      </p>
      {action && (
        <Button
          onClick={action.onClick}
          variant="default"
          size={compact ? 'sm' : 'default'}
          className="mt-4"
        >
          {action.label}
        </Button>
      )}
    </div>
  );
}
